/* ==========================================================================
   lockin — núcleo de JavaScript (nativo, sin dependencias, cargado con defer)

   Módulos:
   1. Utilidades              5. Barra de anuncios
   2. Diálogos y paneles      6. Carrito (Ajax)
   3. Avisos (toast)          7. Consentimiento de cookies
   4. Pestañas                8. Bienvenida, seguimiento, idioma, recomendados

   assets/product.js y assets/search.js usan lo que este archivo publica en
   window.theme (Dialog, toast, Cart, utilidades).
   ========================================================================== */
(function () {
  'use strict';

  /* 1. Utilidades
     ------------------------------------------------------------------------ */
  var config = window.themeConfig || { routes: {}, strings: {} };

  /* Shopify entrega las traducciones con los caracteres especiales codificados
     (' llega como &#39;). Aquí se devuelven a texto normal antes de mostrarlas. */
  function decodeText(value) {
    if (typeof value !== 'string' || value.indexOf('&') < 0) return value;
    var area = document.createElement('textarea');
    area.innerHTML = value;
    return area.value;
  }
  Object.keys(config.strings || {}).forEach(function (key) {
    config.strings[key] = decodeText(config.strings[key]);
  });
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function $$(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json();
    });
  }

  /* Avisa a los demás módulos de que hay contenido nuevo que inicializar. */
  function announceContent(root) {
    document.dispatchEvent(new CustomEvent('theme:content', { detail: { root: root || document } }));
  }

  /* 2. Diálogos y paneles laterales
     Usan <dialog> nativo: foco atrapado, tecla Esc y fondo inerte de serie.
     [data-dialog-open="id"] abre; [data-dialog-close] o un clic en el fondo cierran.
     ------------------------------------------------------------------------ */
  var Dialog = {
    open: function (dialog) {
      if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      return true;
    },

    close: function (dialog) {
      if (dialog && dialog.open) dialog.close();
    },

    anyOpen: function () {
      return $$('dialog[open]').length > 0;
    },
  };

  function initDialogs() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-dialog-open]');
      if (opener) {
        var target = document.getElementById(opener.dataset.dialogOpen);
        if (target && typeof target.showModal === 'function') {
          event.preventDefault();
          Dialog.open(target);
          var autofocus = $('[data-autofocus], input:not([type="hidden"])', target);
          if (autofocus) autofocus.focus();
        }
        return;
      }

      var closer = event.target.closest('[data-dialog-close]');
      if (closer) {
        var parent = closer.closest('dialog');
        /* un enlace dentro del menú navega además de cerrar */
        if (parent) Dialog.close(parent);
        return;
      }

      /* clic en el fondo (fuera del contenido) */
      if (event.target.tagName === 'DIALOG' && event.target.open && !event.target.hasAttribute('data-dialog-static')) {
        var rect = event.target.getBoundingClientRect();
        var inside =
          event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) Dialog.close(event.target);
      }
    });

    /* el evento close no burbujea: se escucha en captura */
    document.addEventListener(
      'close',
      function () {
        if (!Dialog.anyOpen()) document.documentElement.style.overflow = '';
      },
      true
    );
  }

  /* 3. Avisos (toast)
     theme.toast({ title, description, href, linkLabel, variant: 'error', duration })
     ------------------------------------------------------------------------ */
  function toast(options) {
    var toaster = $('[data-toaster]');
    if (!toaster) return;

    var item = document.createElement('div');
    item.className = 'toast' + (options.variant === 'error' ? ' toast--error' : '');
    item.setAttribute('role', options.variant === 'error' ? 'alert' : 'status');

    var title = document.createElement('p');
    title.className = 'toast__title';
    title.textContent = options.title || '';
    item.appendChild(title);

    if (options.description || options.href) {
      var description = document.createElement('p');
      description.className = 'toast__description';
      if (options.description) description.appendChild(document.createTextNode(options.description + ' '));
      if (options.href) {
        var link = document.createElement('a');
        link.href = options.href;
        link.textContent = options.linkLabel || options.href;
        description.appendChild(link);
      }
      item.appendChild(description);
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'toast__close';
    close.setAttribute('aria-label', config.strings.close || 'Cerrar');
    close.innerHTML =
      '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    item.appendChild(close);

    var timer = null;
    function dismiss() {
      window.clearTimeout(timer);
      if (item.parentNode) item.parentNode.removeChild(item);
    }
    function schedule() {
      timer = window.setTimeout(dismiss, options.duration || 5000);
    }

    close.addEventListener('click', dismiss);
    /* el aviso no desaparece mientras se lee o tiene el foco */
    item.addEventListener('mouseenter', function () {
      window.clearTimeout(timer);
    });
    item.addEventListener('mouseleave', schedule);
    item.addEventListener('focusin', function () {
      window.clearTimeout(timer);
    });
    item.addEventListener('focusout', schedule);

    toaster.appendChild(item);
    schedule();
  }

  /* 4. Pestañas
     Patrón ARIA de pestañas con activación automática y flechas del teclado.
     Si la lista de pestañas está oculta por CSS (escritorio), se muestran todos los paneles.
     ------------------------------------------------------------------------ */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (tabs) {
      if (tabs.dataset.ready) return;
      tabs.dataset.ready = 'true';

      var list = $('[role="tablist"]', tabs);
      var triggers = $$('[role="tab"]', tabs);
      var panels = $$('[data-tab-panel]', tabs);

      function listVisible() {
        return list && list.offsetParent !== null;
      }

      function sync() {
        var visible = listVisible();
        triggers.forEach(function (trigger) {
          var selected = trigger.getAttribute('aria-selected') === 'true';
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          trigger.tabIndex = selected ? 0 : -1;
          if (panel) panel.hidden = visible && !selected;
        });
      }

      function select(trigger, focus) {
        triggers.forEach(function (other) {
          other.setAttribute('aria-selected', other === trigger ? 'true' : 'false');
        });
        sync();
        if (focus) trigger.focus();
      }

      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () {
          select(trigger, false);
        });
        trigger.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = triggers[(index + 1) % triggers.length];
          if (event.key === 'ArrowLeft') next = triggers[(index - 1 + triggers.length) % triggers.length];
          if (event.key === 'Home') next = triggers[0];
          if (event.key === 'End') next = triggers[triggers.length - 1];
          if (next) {
            event.preventDefault();
            select(next, true);
          }
        });
      });

      window.addEventListener('resize', sync);
      sync();
      if (!panels.length) return;
    });
  }

  /* 5. Barra de anuncios
     Publica las alturas de la cabecera fija, rota mensajes y permite pausar el movimiento.
     ------------------------------------------------------------------------ */
  function initAnnouncement() {
    var bar = $('[data-announcement]');

    function setHeights() {
      var root = document.documentElement;
      var height = bar && bar.hasAttribute('data-sticky') ? bar.offsetHeight : 0;
      root.style.setProperty('--ann-h', height + 'px');

      var headerHeight = 0;
      ['.section-announcement', '.section-header'].forEach(function (selector) {
        var element = $(selector);
        if (element && window.getComputedStyle(element).position === 'sticky') headerHeight += element.offsetHeight;
      });
      root.style.setProperty('--header-h', headerHeight + 'px');
    }

    setHeights();
    window.addEventListener('resize', setHeights);
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    var pause = $('[data-announcement-pause]', bar);
    if (pause) {
      pause.addEventListener('click', function () {
        var paused = bar.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pause.setAttribute('aria-label', paused ? config.strings.play : config.strings.pause);
      });
    }

    var messages = $$('[data-announcement-msg]', bar);
    if (messages.length < 2 || reducedMotion) return;

    var index = 0;
    var seconds = parseInt(bar.dataset.interval, 10) || 5;
    window.setInterval(function () {
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, seconds * 1000);
  }

  /* 6. Carrito
     Cada contenedor [data-cart-section] (panel lateral o página de carrito) se vuelve a
     pintar con el HTML de la Section Rendering API: sin recargar la página.
     ------------------------------------------------------------------------ */
  var Cart = {
    drawer: function () {
      return $('[data-cart-drawer]');
    },

    sectionIds: function () {
      return $$('[data-cart-section]').map(function (element) {
        return element.dataset.cartSection;
      });
    },

    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        if (!sections[id]) return;
        var current = $('[data-cart-section="' + id + '"]');
        var fresh = $('[data-cart-section="' + id + '"]', parseHTML(sections[id]));
        if (!current || !fresh) return;
        current.innerHTML = fresh.innerHTML;
        current.dataset.itemCount = fresh.dataset.itemCount;
      });
      Cart.updateCount();
    },

    updateCount: function () {
      var container = $('[data-cart-section]');
      if (!container) return;
      var count = parseInt(container.dataset.itemCount, 10) || 0;
      $$('[data-cart-count]').forEach(function (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    },

    setBusy: function (busy) {
      $$('[data-cart-section]').forEach(function (element) {
        element.classList.toggle('is-busy', busy);
        element.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
    },

    showError: function (message) {
      var text = message || config.strings.cartError;
      var boxes = $$('[data-cart-error]');
      var drawer = Cart.drawer();
      var visible = boxes.length && (!drawer || drawer.open || !drawer.contains(boxes[0]));
      if (visible) {
        boxes.forEach(function (box) {
          box.textContent = text;
          box.hidden = false;
        });
      } else {
        toast({ title: text, variant: 'error' });
      }
    },

    request: function (url, body) {
      body.sections = Cart.sectionIds().join(',');
      body.sections_url = window.location.pathname;
      Cart.setBusy(true);
      return postJSON(url, body)
        .then(function (result) {
          if (result.status) {
            Cart.showError(result.description || result.message);
            return false;
          }
          Cart.render(result.sections);
          return Cart.syncGifts().then(function () {
            return true;
          });
        })
        .catch(function () {
          Cart.showError();
          return false;
        })
        .then(function (ok) {
          Cart.setBusy(false);
          return ok;
        });
    },

    /* Carrito: deja cada regalo con cantidad 1 si las cajas llegan a su mínimo y lo quita
       si no (p. ej. al bajar de 2 a 1 caja). Sin regalos configurados no hace nada. */
    syncGifts: function () {
      var gifts = (config.gifts || []).filter(function (gift) {
        return gift && gift.id;
      });
      if (!gifts.length) return Promise.resolve();
      var root = (config.routes && config.routes.root) || '/';
      return fetch(root.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var ids = gifts.map(function (gift) {
            return String(gift.id);
          });
          var boxes = 0;
          var current = {};
          (cart.items || []).forEach(function (item) {
            if (ids.indexOf(String(item.variant_id)) >= 0) current[item.variant_id] = (current[item.variant_id] || 0) + item.quantity;
            else boxes += item.quantity;
          });
          var updates = {};
          var changed = false;
          gifts.forEach(function (gift) {
            var wanted = boxes >= (gift.min || 1) ? 1 : 0;
            if ((current[gift.id] || 0) !== wanted) {
              updates[gift.id] = wanted;
              changed = true;
            }
          });
          if (!changed) return null;
          return postJSON(config.routes.cartUpdate, {
            updates: updates,
            sections: Cart.sectionIds().join(','),
            sections_url: window.location.pathname,
          }).then(function (result) {
            if (result && result.sections) Cart.render(result.sections);
          });
        })
        .catch(function () {
          return null;
        });
    },

    change: function (line, quantity) {
      return Cart.request(config.routes.cartChange, { line: line, quantity: quantity });
    },

    /* Código de descuento: se envía uno solo, que sustituye al anterior. Si Shopify
       responde que no se puede aplicar, se recupera el que hubiera y se avisa. */
    discount: function (code, previous) {
      function send(value) {
        return postJSON(config.routes.cartUpdate, {
          discount: value,
          sections: Cart.sectionIds().join(','),
          sections_url: window.location.pathname,
        });
      }

      Cart.setBusy(true);
      return send(code)
        .then(function (result) {
          if (result.status) {
            Cart.showError(result.description || result.message);
            return null;
          }
          var rejected = (result.discount_codes || []).some(function (entry) {
            return code && String(entry.code).toLowerCase() === code.toLowerCase() && !entry.applicable;
          });
          if (!rejected) {
            Cart.render(result.sections);
            return null;
          }
          return send(previous || '').then(function (restored) {
            Cart.render(restored.sections);
            Cart.showError(config.strings.discountError);
          });
        })
        .catch(function () {
          Cart.showError();
        })
        .then(function () {
          Cart.setBusy(false);
        });
    },

    add: function (variantId) {
      return Cart.request(config.routes.cartAdd, { items: [{ id: variantId, quantity: 1 }] });
    },

    /* Varias líneas a la vez, p. ej. un pack con una caja azul y otra verde:
       [[variante, cantidad], …]. Las líneas de la misma variante se suman. */
    addLines: function (lines) {
      var merged = {};
      var order = [];
      lines.forEach(function (line) {
        var id = String(line[0]);
        if (!merged[id]) order.push(id);
        merged[id] = (merged[id] || 0) + (parseInt(line[1], 10) || 1);
      });
      return Cart.request(config.routes.cartAdd, {
        items: order.map(function (id) {
          return { id: Number(id), quantity: merged[id] };
        }),
      });
    },

    open: function () {
      var drawer = Cart.drawer();
      if (!drawer) return false;
      /* si hay otro diálogo abierto (vista rápida), se cierra antes */
      $$('dialog[open]').forEach(function (other) {
        if (other !== drawer) other.close();
      });
      return Dialog.open(drawer);
    },

    close: function () {
      Dialog.close(Cart.drawer());
    },
  };

  function applyDiscount(box) {
    var field = box && $('[data-discount-input]', box);
    var code = field ? field.value.trim() : '';
    if (!code) return;
    var current = $('[data-discount-remove]', box);
    Cart.discount(code, current ? current.dataset.code : '');
  }

  function initCart() {
    /* Intro en el campo del código lo aplica; no envía el carrito al pago. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.matches('[data-discount-input]')) return;
      event.preventDefault();
      applyDiscount(event.target.closest('[data-cart-discount]'));
    });

    document.addEventListener('click', function (event) {
      var target = event.target;

      if (target.closest('[data-cart-open]') && Cart.drawer()) {
        event.preventDefault();
        Cart.open();
        return;
      }

      var step = target.closest('[data-qty-step]');
      if (step) {
        var input = $('input', step.parentElement);
        var min = parseInt(input.min, 10) || 0;
        var value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
        input.value = value;
        if (input.hasAttribute('data-qty-input')) Cart.change(parseInt(input.dataset.line, 10), value);
        return;
      }

      var remove = target.closest('[data-remove-line]');
      if (remove) {
        event.preventDefault();
        Cart.change(parseInt(remove.dataset.removeLine, 10), 0);
        return;
      }

      var apply = target.closest('[data-discount-apply]');
      if (apply) {
        applyDiscount(apply.closest('[data-cart-discount]'));
        return;
      }

      if (target.closest('[data-discount-remove]')) {
        Cart.discount('');
        return;
      }

      var upsell = target.closest('[data-upsell-add]');
      if (upsell) {
        upsell.classList.add('is-loading');
        Cart.add(parseInt(upsell.dataset.upsellAdd, 10));
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-qty-input]');
      if (input) Cart.change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  /* 7. Consentimiento de cookies
     Guarda la elección con la Customer Privacy API de Shopify. Shopify decide si hace falta
     pedirlo (shouldShowBanner) según las regiones configuradas en Privacidad del cliente.
     Ningún script de analítica o marketing gestionado por Shopify se carga antes.
     ------------------------------------------------------------------------ */
  function initCookies() {
    var banner = $('[data-cookie-banner]');
    if (!banner) return;

    var KEY = 'theme-cookie-consent';
    var prefs = $('[data-cookie-prefs]', banner);
    var saveButton = $('[data-cookie-save]', banner);
    var configureButton = $('[data-cookie-configure]', banner);
    var acceptButton = $('[data-cookie-accept]', banner);
    var rejectButton = $('[data-cookie-reject]', banner);
    var api = null;

    var SEEN = 'theme-cookie-seen';
    var remember = banner.dataset.remember !== 'false';

    function store() {
      return remember ? window.localStorage : window.sessionStorage;
    }

    function stored() {
      try {
        return JSON.parse(store().getItem(KEY));
      } catch (error) {
        return null;
      }
    }

    function seenThisVisit() {
      try {
        return window.sessionStorage.getItem(SEEN) === '1';
      } catch (error) {
        return false;
      }
    }

    function markSeen() {
      try {
        window.sessionStorage.setItem(SEEN, '1');
      } catch (error) {
        /* sin almacenamiento de sesión el aviso se muestra en cada página */
      }
    }

    function apply(consent) {
      try {
        store().setItem(KEY, JSON.stringify(consent));
      } catch (error) {
        /* almacenamiento no disponible: se sigue con la API de Shopify */
      }
      if (api && typeof api.setTrackingConsent === 'function') {
        api.setTrackingConsent(
          {
            analytics: consent.analytics,
            marketing: consent.marketing,
            preferences: consent.preferences,
            sale_of_data: consent.marketing,
          },
          function () {}
        );
      }
      banner.hidden = true;
      document.dispatchEvent(new CustomEvent('theme:consent'));
    }

    function showPrefs() {
      prefs.hidden = false;
      saveButton.hidden = false;
    }

    function show() {
      var consent = stored() || {};
      $$('[data-cookie-opt]', banner).forEach(function (input) {
        input.checked = !!consent[input.dataset.cookieOpt];
      });
      banner.hidden = false;
    }

    acceptButton.addEventListener('click', function () {
      apply({ analytics: true, marketing: true, preferences: true });
    });

    rejectButton.addEventListener('click', function () {
      apply({ analytics: false, marketing: false, preferences: false });
    });

    configureButton.addEventListener('click', showPrefs);

    saveButton.addEventListener('click', function () {
      var consent = {};
      $$('[data-cookie-opt]', banner).forEach(function (input) {
        consent[input.dataset.cookieOpt] = input.checked;
      });
      apply(consent);
    });

    /* Enlace permanente del pie: cambiar o retirar el consentimiento */
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-cookie-open]')) return;
      show();
      showPrefs();
      prefs.querySelector('input:not([disabled])').focus();
    });

    /* Si la tienda tiene activo el aviso de cookies de Shopify (Configuración > Privacidad
       del cliente), el del tema se retira para que no salgan dos. */
    function nativeBanner() {
      return !!(
        window.privacyBanner ||
        document.getElementById('shopify-pc__banner') ||
        document.querySelector('a[href*="shopifyReshowConsentBanner"], script[src*="privacy-banner"]')
      );
    }

    function yieldToNative() {
      banner.hidden = true;
      $$('[data-cookie-open]').forEach(function (button) {
        button.hidden = true;
      });
    }

    /* El aviso sale una sola vez por visita. Si ya hay una elección guardada no se vuelve
       a preguntar: se reenvía a Shopify por si no la tenía registrada. */
    function decide() {
      if (nativeBanner()) {
        yieldToNative();
        return;
      }
      var consent = stored();
      if (consent) {
        if (api && typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()) {
          api.setTrackingConsent(
            {
              analytics: !!consent.analytics,
              marketing: !!consent.marketing,
              preferences: !!consent.preferences,
              sale_of_data: !!consent.marketing,
            },
            function () {}
          );
        }
        return;
      }
      if (seenThisVisit()) return;
      if (api && typeof api.shouldShowBanner === 'function' && !api.shouldShowBanner()) return;
      markSeen();
      show();
    }

    /* El aviso de Shopify se carga más tarde que el tema: se comprueba otra vez. */
    [1200, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        if (nativeBanner()) yieldToNative();
      }, delay);
    });

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) api = window.Shopify.customerPrivacy;
        decide();
      });
    } else {
      decide();
    }
  }

  /* 8. Bienvenida, seguimiento, idioma y recomendados
     ------------------------------------------------------------------------ */

  /* Mensaje de bienvenida: una vez por visitante, tras unos segundos y cuando no hay
     ni aviso de cookies ni otro diálogo abierto. */
  function initPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;

    var KEY = 'theme-signup-popup';

    function remember(value) {
      try {
        window.localStorage.setItem(KEY, value);
      } catch (error) {
        /* sin almacenamiento, el mensaje puede volver a mostrarse */
      }
    }

    function seen() {
      try {
        return !!window.localStorage.getItem(KEY);
      } catch (error) {
        return false;
      }
    }

    popup.addEventListener('close', function () {
      remember('closed');
    });

    /* Código de bienvenida: el botón lo copia y, de paso, lo deja aplicado para el
       carrito y el pago mediante el enlace de descuento de Shopify. */
    var codeButton = $('[data-popup-code]', popup);
    if (codeButton) {
      var applied = false;
      var copyCode = function (code) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(code).catch(function () {});
        }
        var text = $('[data-popup-code-text]', popup);
        var range = document.createRange();
        range.selectNodeContents(text);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        try {
          document.execCommand('copy');
        } catch (error) {
          /* el código queda seleccionado para copiarlo a mano */
        }
        return null;
      };
      var applyCode = function (code) {
        if (applied) return;
        applied = true;
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () {
            var cartBox = $('[data-cart-section]');
            if (cartBox && parseInt(cartBox.dataset.itemCount, 10) > 0) Cart.discount(code);
          })
          .catch(function () {
            applied = false;
          });
      };
      codeButton.addEventListener('click', function () {
        var code = codeButton.dataset.popupCode;
        copyCode(code);
        try {
          window.localStorage.setItem('theme-discount', code);
        } catch (error) {
          /* sin almacenamiento, el código se escribe a mano en el pago */
        }
        codeButton.textContent = codeButton.dataset.copied;
        codeButton.classList.add('is-copied');
        applyCode(code);
      });
    }

    if ($('[data-popup-success]', popup)) {
      remember('done');
      Dialog.open(popup);
      return;
    }

    if ($('[data-popup-error]', popup)) {
      Dialog.open(popup);
      return;
    }

    if (seen() || (window.Shopify && window.Shopify.designMode)) return;

    /* No tapa la primera pantalla: espera al retraso elegido y, además, a que el visitante
       haya bajado más allá de la compra (o a 30 s más), para no cubrir el botón al entrar. */
    var delay = (parseInt(popup.dataset.delay, 10) || 0) * 1000;
    var started = Date.now();
    var scrolledPast = function () {
      return window.scrollY > window.innerHeight * 0.9;
    };
    window.setTimeout(function tryOpen() {
      var banner = $('[data-cookie-banner]');
      var waited = Date.now() - started > delay + 30000;
      if ((banner && !banner.hidden) || Dialog.anyOpen() || !(scrolledPast() || waited)) {
        window.setTimeout(tryOpen, 1500);
        return;
      }
      Dialog.open(popup);
    }, delay);
  }

  function initTracking() {
    $$('[data-tracking-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var template = form.dataset.trackerUrl || '';
        var number = (form.elements.numero.value || '').trim();
        if (!number || template.indexOf('http') !== 0) return;
        window.open(template.replace('{numero}', encodeURIComponent(number)), '_blank', 'noopener');
      });
    });
  }

  /* Selector de idioma de la cabecera: se cierra con Escape o al pulsar fuera. */
  function initLanguageMenu() {
    document.addEventListener('click', function (event) {
      $$('[data-lang][open]').forEach(function (menu) {
        if (!menu.contains(event.target)) menu.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      $$('[data-lang][open]').forEach(function (menu) {
        menu.removeAttribute('open');
        var summary = menu.querySelector('summary');
        if (summary) summary.focus();
      });
    });
  }

  function initLocalization() {
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-localization] select');
      if (select && select.form) select.form.submit();
    });
  }

  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (container) {
      if (container.innerHTML.trim() !== '' || !container.dataset.url) return;
      fetch(container.dataset.url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var fresh = $('[data-recommendations]', parseHTML(html));
          if (fresh && fresh.innerHTML.trim() !== '') {
            container.innerHTML = fresh.innerHTML;
            announceContent(container);
          }
        })
        .catch(function () {
          /* sin recomendaciones no se muestra nada */
        });
    });
  }

  /* Compra directa: al pago de Shopify con el enlace de carrito (variante:cantidad),
     sin pasar por el carrito. Si el visitante copió su código de bienvenida, se añade
     cuando compra una unidad (con dos o más ya se aplica el descuento por cantidad).
     ------------------------------------------------------------------------ */
  var DISCOUNT_KEY = 'theme-discount';

  /* La ruta lleva el prefijo de idioma y mercado (p. ej. /es-es/): sin él, Shopify
     abre la pantalla de pago en el idioma por defecto de la tienda (inglés). */
  function cartPath() {
    var root = (config.routes && config.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart/';
  }

  /* Regalos digitales (Configuración del tema > Regalos digitales): se añaden solos al
     pedido según las cajas. El descuento automático «Compra X, llévate Y» de Shopify
     los deja a 0 € en el pago, con su precio tachado. */
  function giftList() {
    return (config.gifts || []).filter(function (gift) {
      return gift && gift.id;
    });
  }

  function isGift(id) {
    return giftList().some(function (gift) {
      return String(gift.id) === String(id);
    });
  }

  function countBoxes(lines) {
    return lines.reduce(function (sum, line) {
      return isGift(line[0]) ? sum : sum + (parseInt(line[1], 10) || 1);
    }, 0);
  }

  function withGifts(lines) {
    var gifts = giftList();
    if (!gifts.length) return lines;
    var boxes = countBoxes(lines);
    var result = lines.filter(function (line) {
      return !isGift(line[0]);
    });
    gifts.forEach(function (gift) {
      if (boxes >= (gift.min || 1)) result.push([gift.id, 1]);
    });
    return result;
  }

  /* Admite una variante y cantidad, o una lista de líneas [[variante, cantidad], …]
     (p. ej. una caja azul y otra verde). */
  function goCheckout(variantId, quantity) {
    var lines = Array.isArray(variantId) ? variantId : [[variantId, quantity || 1]];
    /* El código de bienvenida solo va con 1 caja: se cuentan las cajas antes de sumar regalos. */
    var boxes = countBoxes(lines);
    lines = withGifts(lines);
    var merged = {};
    var order = [];
    lines.forEach(function (line) {
      var id = String(line[0]);
      if (!merged[id]) order.push(id);
      merged[id] = (merged[id] || 0) + (parseInt(line[1], 10) || 1);
    });
    /* El pago de Shopify enseña las líneas al revés de como llegan (la última, arriba). Se
       mandan en orden inverso para que salgan primero las cajas y después los regalos. */
    order.reverse();
    var url = cartPath() + order.map(function (id) {
      return id + ':' + merged[id];
    }).join(',');
    quantity = boxes;
    var code = '';
    try {
      code = window.localStorage.getItem(DISCOUNT_KEY) || '';
    } catch (error) {
      code = '';
    }
    if (code && (quantity || 1) === 1) url += '?discount=' + encodeURIComponent(code);
    window.location.href = url;
  }

  function initBuyDialog() {
    var dialog = $('[data-buy-dialog]');

    /* el botón muestra el total de la opción marcada */
    function syncPrices() {
      if (!dialog) return;
      var chosen = $('[data-buy-qty]:checked', dialog);
      var card = chosen ? chosen.closest('.pack__card') : null;
      var price = card ? $('[data-card-price]', card) : null;
      var total = $('[data-buy-total]', dialog);
      if (price && total) total.textContent = price.textContent;
    }

    function chosenLines() {
      var chosen = $('[data-buy-qty]:checked', dialog);
      var quantity = chosen ? parseInt(chosen.value, 10) || 1 : 1;
      var submit = $('[data-buy-submit]', dialog);
      var groups = $$('[data-buy-unit="' + quantity + '"]', dialog);
      if (!groups.length) return [[submit.dataset.variant, quantity]];
      return groups.map(function (group) {
        var picked = $('input:checked', group);
        return [picked ? picked.value : submit.dataset.variant, 1];
      });
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-buy-open]');
      if (opener && dialog) {
        event.preventDefault();
        syncPrices();
        Dialog.open(dialog);
        return;
      }
      var submit = event.target.closest('[data-buy-submit]');
      if (submit) {
        submit.classList.add('is-loading');
        if (config.directCheckout) {
          goCheckout(chosenLines());
          return;
        }
        /* Con carrito: se añaden las cajas y colores elegidos y se abre el carrito
           (o se va a la página del carrito si no hay panel lateral). */
        Cart.addLines(chosenLines()).then(function (ok) {
          submit.classList.remove('is-loading');
          if (!ok) return;
          Dialog.close(dialog);
          if (!Cart.open()) window.location.href = config.routes.cart;
        });
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-buy-qty]')) syncPrices();
    });

    /* al volver atrás desde el pago, ningún botón se queda en estado de carga */
    window.addEventListener('pageshow', function () {
      $$('.btn.is-loading').forEach(function (button) {
        button.classList.remove('is-loading');
      });
    });
  }

  /* Arranque
     ------------------------------------------------------------------------ */
  window.theme = {
    config: config,
    reducedMotion: reducedMotion,
    decodeText: decodeText,
    $: $,
    $$: $$,
    parseHTML: parseHTML,
    Dialog: Dialog,
    Cart: Cart,
    toast: toast,
    announceContent: announceContent,
    goCheckout: goCheckout,
    cartPath: cartPath,
  };

  initDialogs();
  initAnnouncement();
  initTabs(document);
  initCart();
  initCookies();
  initTracking();
  initLocalization();
  initLanguageMenu();
  initPopup();
  initBuyDialog();
  initRecommendations();

  document.addEventListener('theme:content', function (event) {
    initTabs(event.detail.root);
  });

  /* El personalizador de Shopify vuelve a pintar secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncement();
    announceContent(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    if ($('[data-cart-drawer]', event.target)) Cart.open();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if ($('[data-cart-drawer]', event.target)) Cart.close();
  });
})();

/* Políticas nativas de Shopify (/policies/…): se les da la misma estructura que a las
   páginas legales del tema (apartados numerados e índice) a partir de sus títulos. */
(function () {
  var container = document.querySelector('.shopify-policy__container');
  var body = container && container.querySelector('.shopify-policy__body');
  if (!body) return;
  var content = body.querySelector('.rte') || body;
  var headings = content.querySelectorAll('h2');
  if (headings.length < 2) headings = content.querySelectorAll('h1, h3');
  if (headings.length < 2) headings = content.querySelectorAll('p > strong:only-child, p > b:only-child');
  container.classList.add('legal', 'legal--policy');
  container.setAttribute('data-legal', '');
  var layout = document.createElement('div');
  layout.className = 'legal__layout';
  var main = document.createElement('div');
  main.className = 'legal__body';
  body.parentNode.insertBefore(layout, body);
  main.appendChild(body);
  if (headings.length > 3) {
    var strings = (window.themeConfig && window.themeConfig.strings) || {};
    var nav = document.createElement('nav');
    nav.className = 'legal__index';
    nav.setAttribute('aria-label', strings.legalIndex || '');
    var title = document.createElement('p');
    title.className = 'legal__index-title';
    title.textContent = strings.legalIndex || '';
    var list = document.createElement('ol');
    Array.prototype.forEach.call(headings, function (heading, i) {
      var target = heading.tagName.charAt(0) === 'H' ? heading : heading.parentNode;
      var id = 'apartado-' + (i + 1);
      var label = heading.textContent.replace(/^\s*\d+[.)]\s*/, '').trim();
      target.id = id;
      target.setAttribute('data-legal-block', '');
      target.classList.add('legal__heading', 'legal__heading--policy');
      var number = document.createElement('span');
      number.className = 'legal__number';
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(i + 1);
      var text = document.createElement('span');
      text.textContent = label;
      target.textContent = '';
      target.appendChild(number);
      target.appendChild(text);
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.setAttribute('data-legal-link', '');
      link.textContent = label;
      item.appendChild(link);
      list.appendChild(item);
    });
    nav.appendChild(title);
    nav.appendChild(list);
    layout.classList.add('legal__layout--index');
    layout.appendChild(nav);
  }
  layout.appendChild(main);
})();

/* Páginas legales: resalta en el índice el apartado que se está leyendo. */
(function () {
  var root = document.querySelector('[data-legal]');
  if (!root || !('IntersectionObserver' in window)) return;
  var links = {};
  root.querySelectorAll('[data-legal-link]').forEach(function (link) {
    links[link.getAttribute('href').slice(1)] = link;
  });
  var blocks = root.querySelectorAll('[data-legal-block]');
  if (!blocks.length || !Object.keys(links).length) return;
  if (links[blocks[0].id]) links[blocks[0].id].setAttribute('aria-current', 'true');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      Object.keys(links).forEach(function (id) {
        if (id === entry.target.id) links[id].setAttribute('aria-current', 'true');
        else links[id].removeAttribute('aria-current');
      });
    });
  }, { rootMargin: '-25% 0px -65% 0px' });
  blocks.forEach(function (block) { observer.observe(block); });
})();

/* Demostración en vídeo: el archivo solo se carga al pulsar el botón. Al empezar uno,
   se pausan los demás. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-video-play]');
    if (!button) return;
    var frame = button.closest('[data-video-demo]');
    var template = frame && frame.querySelector('[data-video-template]');
    if (!template) return;
    frame.appendChild(template.content.cloneNode(true));
    template.parentNode.removeChild(template);
    button.hidden = true;
    var poster = frame.querySelector('.video-demo__poster');
    if (poster) poster.hidden = true;
    var video = frame.querySelector('video');
    if (!video) return;
    video.addEventListener('play', function () {
      document.querySelectorAll('video').forEach(function (other) {
        if (other !== video && !other.paused) other.pause();
      });
    });
    var started = video.play();
    if (started && typeof started.catch === 'function') started.catch(function () {});
    video.focus();
  });
})();

/* Desistimiento en diálogo: tras enviar el formulario, Shopify vuelve a la página con el
   identificador del formulario en la dirección; se reabre para mostrar la confirmación. */
(function () {
  var dialog = document.querySelector('[data-withdrawal-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  if (window.location.hash === '#withdrawal-dialog-form' && !dialog.open) dialog.showModal();
})();

/* ==========================================================================
   Enlaces internos con otro nombre: si un enlace apunta a una sección que no existe
   (#testimonios, #como-funciona…), lleva a la sección equivalente que sí hay en la
   página. Así el menú, las estrellas y la barra de compra no se quedan sin hacer nada
   aunque se cambie el ancla de una sección.
   ========================================================================== */
(function () {
  'use strict';
  var aliases = {
    testimonios: ['opiniones', 'resenas', 'reviews'],
    opiniones: ['testimonios', 'resenas', 'reviews'],
    'como-funciona': ['demostracion', 'video', 'pasos'],
    demostracion: ['como-funciona', 'video'],
    comprar: ['caja', 'producto']
  };
  /* Si no hay ningún alias, se busca la sección por su tipo. */
  var bySection = {
    testimonios: '.testimonials',
    opiniones: '.testimonials',
    'como-funciona': '.video-demo, .steps',
    demostracion: '.video-demo',
    comprar: '.pdp'
  };

  function findTarget(id) {
    if (!id) return null;
    var direct = document.getElementById(id);
    if (direct) return direct;
    var list = aliases[id] || [];
    for (var i = 0; i < list.length; i += 1) {
      var alt = document.getElementById(list[i]);
      if (alt) return alt;
    }
    if (bySection[id]) {
      var section = document.querySelector(bySection[id]);
      if (section) return section.closest('.shopify-section') || section;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (error) {
      return;
    }
    /* Solo enlaces a esta misma página */
    if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
    var id = decodeURIComponent(url.hash.slice(1));
    if (!id || id.indexOf('shopify') === 0 || document.getElementById(id)) return;
    var target = findTarget(id);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (target.id) history.replaceState(null, '', '#' + target.id);
  });

  /* Al llegar desde otra página con un ancla antigua (p. ej. /es-es#como-funciona) */
  window.addEventListener('load', function () {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id || document.getElementById(id)) return;
    var target = findTarget(id);
    if (target) target.scrollIntoView({ block: 'start' });
  });
})();
